import React, { useRef } from "react";
import styles from '../../css/Part8.module.css';
import style from '../../css/Part9.module.css';

const benefitItems = [
  "Convert your promotion into hyper deals with FoneApp",
  "Increase traffic flow to your brand with support from FoneApp Marketing",
  "FoneApp will shout out to our 100,000 registered users to visit your brand",
  "Cross-promote your brand for higher engagement",
  "Exclusive Marketing & Advertising for new merchants",
  "Community of Loyal Customers"
];

function BenefitItem({ number, description }) {
  return (
    <>
      <div className={styles.benefitNumber}>{number}</div>
      <div className={styles.benefitDescription}>{description}</div>
    </>
  );
}
function BenefitItem1({ number1, description1 }) {
  return (
    <>
      <div className={styles.benefitNumber1}>{number1}</div>
      <div className={styles.benefitDescription1}>{description1}</div>
    </>
  );
}

function BenefitMerchant() {
  const form = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Construct form data to send in the API request
    const formData = new FormData(form.current);
    const data = {
      formType: 'benefit',
      contactName: formData.get("contactName"),
      contactNumber: formData.get("contactNumber"),
      email: formData.get("email"),
      companyName: formData.get("companyName"),
      businessIndustry: formData.get("businessIndustry"),
      findUs: formData.get("findUs"),
      question: formData.get("question"),
    };

    // Make a POST request to your backend API
    try {
      const response = await fetch("https://fone_api.gakkixmasami.com/send", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert("Application submitted successfully!");
      } else {
        throw new Error("Failed to submit application");
      }
    } catch (error) {
      console.error("Error submitting application:", error);
      alert("Failed to submit application.");
    }

    // Reset the form after submission
    e.target.reset();
  };

  return (
    <section className={styles.benefitMerchant}>
      <img 
        src="images/background/background effect2.png" 
        alt="" 
        className={styles.backgroundImage} 
        aria-hidden="true" 
      />
      <div className={styles.contentWrapper}>
        <div className={styles.flexContainer}>
          <div className={styles.textColumn}>
            <div className={styles.textContent}>
              <h2 className={styles.title}>Benefit as our merchant</h2>
              <div className={styles.benefitList}>
                <BenefitItem number={1} description={benefitItems[0]} />
                <BenefitItem number={2} description={benefitItems[1]} />
                <BenefitItem number={3} description={benefitItems[2]} />
                <BenefitItem number={4} description={benefitItems[3]} />
                <BenefitItem number={5} description={benefitItems[4]} />
                <BenefitItem1 number1={6} description1={benefitItems[5]} />
              </div>
            </div>
          </div>
          
          <div className={styles.imageColumn}>
          <form className={styles.merchantForm} ref={form} onSubmit={handleSubmit}>
              <h2>FONEAPP MERCHANT APPLICATION</h2>
              <p>Complete the form below, we'll get in touch as soon as we can.</p>
              
              <label>
                Contact Name:
                <input type="text" name="contactName" placeholder="Eg. Simon" />
              </label>
              
              <label>
                Contact Number:
                <input type="text" name="contactNumber" placeholder="017-3456784" />
              </label>
              
              <label>
                Email:
                <input type="email" name="email" placeholder="Eg: MV Asia Sdn Bhd" />
              </label>
              
              <label>
                Company/Brand Name:
                <input type="Company" name="companyName" placeholder="Eg: Uncle Don's" />
              </label>
              
              <label>
                Business Industry:
                <input type="Business Industry" name="businessIndustry" placeholder="Eg: Food & Beverage" />
              </label>
              
              <label>
                Where do you find us:
                <select name="findUs">
                  <option value="" disabled selected>[Please Select]</option>
                  <option value="website">Website</option>
                  <option value="facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                </select>
              </label>
              
              <label>
                Question:
                <textarea placeholder="[Message]" name="question" ></textarea>
              </label>

              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      </div>

      <section className={styles.container} id="section_FonePlus">
                <img src="images/background/foneplus back.png" alt="Green background" className={styles.headerBackground}/>
                <img src="images/icons/FonePlus logo.png" alt="FonePlus logo" className={styles.foneplusLogo} />
            <div className={styles.contentSection}>
                <h1>Level Up Your Loyalty Program With FonePlus Premium Membership</h1>
                <p>
                    FonePlus is a Premium membership program within FoneApp, available to all users in Malaysia. It offers exclusive benefits like higher 
                    rewards through the Community Growth Program (CGP).
                <br/>
                    Community Growth Program (CGP) rewards Premium Members as they recommend this program to other Premium members. For each Premium Member 
                    that joins and is recommended by you, a reward of 100FP (equivalent RM100) will be given.
                </p>
            </div>
      </section>


      {/* Why Join FonePlus Section */}
      <section className={style.whyJoinSection}>
        <h2>Why Join FonePlus?</h2>
        <div className={style.benefits}>

          <div className={style.benefitCardContainer}>
            <img src="images/icons/icon rewards.png" alt="Higher Rewards Icon" className={style.iconImage} />
            <div
              className={style.benefitCard}
              style={{
                background: `url('images/background/Rectangle 24.png') no-repeat center center`,
                backgroundSize: 'cover',
              }}
            >
              <h3>HIGHER REWARDS</h3>
              <p>
                As a Premium user, you'll earn RM100 (FP) referral rebate every time you refer a friend to join FoneApp Premium. NO CAPPED on referral rebate.
              </p>
            </div>
          </div>

          <div className={style.benefitCardContainer}>
            <img src="images/icons/iconn deals.png" alt="Exclusive Deals Icon" className={style.iconImage} />
            <div
              className={style.benefitCard}
              style={{
                background: `url('images/background/Rectangle 24.png') no-repeat center center`,
                backgroundSize: 'cover',
              }}
            >
              <h3>EXCLUSIVE DEALS</h3>
              <p>
                Entitle to 50% rebate for ALL spendings on FoneApp for FIRST THREE calendar months. CAPPED at 100FP each month per account.
              </p>
            </div>
          </div>

          <div className={style.benefitCardContainer}>
            <img src="images/icons/icon invitation.png" alt="Community Invitation Icon" className={style.iconImage1} />
            <div
              className={style.benefitCard}
              style={{
                background: `url('images/background/Rectangle 24.png') no-repeat center center`,
                backgroundSize: 'cover',
              }}
            >
              <h3>INVITATION TO FONEPLUS COMMUNITY</h3>
              <p>
                Invitation to private FonePlus member community platform to receive exclusive updates and latest campaigns.
              </p>
            </div>
          </div>

        </div>
      </section>

    </section>
  );
}

export default BenefitMerchant;
